import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import MainContainer from "pages/_components/MainContainer";
import { ResponsiveHeader } from "pages/_components/header";
import Notification from "pages/_components/Notification";
import GeneralCredentialForm from "pages/_components/Forms/GeneralCredentialForm";
import { actions as accountsActions } from "reducers/accounts";
import { useConfirmTransaction } from "hooks/useConfirmTransaction";
import * as i18n from "util/i18n";
import { actions as afipActions } from "reducers/afipPayments";
import * as configUtils from "util/config";
import AfipSummaryBody from "./components/Summary";

const AfipPaymentsSummaryPage = () => {
    const { afipTaxForm, afipTicket, afipPaymentData, afipBarCode, afipPaymentPrepare, fetching } = useSelector(
        (state) => state.afipPayments,
    );
    const { accounts } = useSelector((state) => state.accounts);
    const account = accounts.find((e) => e?.productId === afipPaymentData.debitAccount);
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(accountsActions.listAccounts());
    }, []);
    useEffect(() => {
        if (Object.keys(afipBarCode).length > 0) {
            dispatch(
                afipActions.afipPaymentPrepareReducer(
                    afipPaymentData.form,
                    afipBarCode.barcode,
                    afipBarCode.amount,
                    afipPaymentData.valuesNoForm,
                    afipPaymentData.taxForm,
                    afipBarCode.hash,
                ),
            );
        }
    }, [afipBarCode, afipPaymentData, afipTaxForm]);

    const data = {
        afipTaxForm,
        afipPaymentData,
        afipBarCode,
        form: afipPaymentData?.formName,
        formData: afipPaymentData?.formData,
        taxData: afipTaxForm.taxForms,
        account: account?.shortLabel,
        totalAmount: afipPaymentData.amount,
        amount: {
            quantity: afipPaymentData.amount,
            currency: configUtils.get("afip.currency.default", "ARS"),
        },
        taxFormData: afipPaymentData.taxFormData,
        operationId: afipPaymentPrepare?.operationId,
        idTransaction: afipPaymentData?.idTransaction,
        notification: false,
        debitAccount: afipPaymentData?.debitAccount,
        enrollService: false,
    };
    useConfirmTransaction(data, afipTicket, "payments/afip");

    return (
        <>
            <Notification scopeToShow="afip.newPayment.sumary" />
            <ResponsiveHeader id="afipPayments.newAfip.title" />
            <MainContainer className="afip-payment-details-list" showLoader={fetching}>
                <div className="container">
                    <h2 className="text-lead afip-title-detail">{i18n.get("afip.payment.confirm")}</h2>
                    <AfipSummaryBody
                        form={afipPaymentData?.formName}
                        formData={afipPaymentData?.formData}
                        taxData={afipTaxForm?.taxForms}
                        account={account?.shortLabel}
                        totalAmount={afipPaymentData.amount}
                        taxFormData={afipPaymentData.taxFormData}
                    />
                    <GeneralCredentialForm
                        transactionData={data}
                        action={afipActions.afipPaymentConfirmReducer}
                        customIndications={i18n.get("afip.indications")}
                        idActivity="rapipago.operation.confirm"
                        isToken
                    />
                </div>
            </MainContainer>
        </>
    );
};

export default AfipPaymentsSummaryPage;
